import { TenantApp } from 'application/Shared/types/tenantApp';
import { UserApp } from 'application/Shared/types/userApp';

import { ColumnFilter } from '../Table/types';

/**
 * Filter configuration for application sources
 * Defines the available filter options for source types in the application table
 * @type {ColumnFilter<UserApp | TenantApp>} Filter configuration object that works with both UserApp and TenantApp types
 */
export const sourcesFilter: ColumnFilter<UserApp | TenantApp> = {
    defaultOptions: [
        {
            group: 'categories',
            options: ['desktop', 'webActivity']
        },
        {
            group: 'webActivity',
            options: ['quickScan', 'download', 'webLogin']
        },
        {
            group: 'integrationsActivity',
            options: ['azure', 'google', 'okta']
        },
        { group: 'ssoActivity', options: ['microsoftSSO', 'googleSSO'] }
    ]
};
